import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { BadgeCheckIcon, XIcon } from "lucide-react";
import { buyers, Buyer } from "../data/buyers";
import { MOCKUP_IMAGE } from "../data/links";
const FIRST_DELAY = 5000;
const VISIBLE_FOR = 5000;
const GAP = 9000;
export function PurchasePopup() {
  const [current, setCurrent] = useState<(Buyer & {
    minutes: number;
  }) | null>(null);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    let hideTimer: number;
    let showTimer: number;
    let index = Math.floor(Math.random() * buyers.length);
    const show = () => {
      index = (index + 1 + Math.floor(Math.random() * 3)) % buyers.length;
      setCurrent({
        ...buyers[index],
        minutes: 1 + Math.floor(Math.random() * 14)
      });
      hideTimer = window.setTimeout(() => {
        setCurrent(null);
        showTimer = window.setTimeout(show, GAP);
      }, VISIBLE_FOR);
    };
    showTimer = window.setTimeout(show, FIRST_DELAY);
    return () => {
      window.clearTimeout(hideTimer);
      window.clearTimeout(showTimer);
    };
  }, [dismissed]);
  return <div className="pointer-events-none fixed bottom-28 left-3 right-3 z-50 sm:right-auto sm:w-[360px]" aria-live="polite" data-id="element-59" data-mp="1151xjzwzatmy">
      <AnimatePresence data-id="element-60" data-mp="1awzcnhr3y5qy">
        {current && !dismissed && <motion.div key={current.name + current.minutes} className="pointer-events-auto relative flex items-center gap-3 rounded-2xl bg-white p-3 pr-9 shadow-2xl ring-1 ring-navy-900/10" initial={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} transition={{
        duration: 0.22,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-61" data-mp="1aysjoy5murzh">
            <img src={MOCKUP_IMAGE} alt="" className="h-14 w-14 shrink-0 rounded-xl bg-mist object-contain" data-id="element-62" data-mp="28jesyg7ssxcx" />
            <div className="min-w-0" data-id="element-63" data-mp="2aol66hya2k5d">
              <p className="truncate text-sm font-bold text-ink" data-id="element-64" data-mp="2anjkzknjsh9x">
                {current.name} <span className="font-medium text-ink-muted" data-id="element-65" data-mp="2fmv2ivvqnqsk">from {current.country}</span>
              </p>
              <p className="text-[13px] leading-snug text-ink" data-id="element-66" data-mp="2kmhcmwg9sqx5">
                just purchased the <strong data-id="element-67" data-mp="2pmdkx7w034ii">Alopecia Clinical Blueprint™</strong>
              </p>
              <p className="mt-0.5 flex items-center gap-1 text-xs font-semibold text-success" data-id="element-68" data-mp="1ry3hcogkg8pa">
                <BadgeCheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-69" data-mp="1wx6apbn6oqhf" />
                Verified purchase · {current.minutes} min ago
              </p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} className="absolute right-2 top-2 rounded-full p-1 text-ink-muted transition-colors duration-150 hover:bg-mist hover:text-ink" aria-label="Close notification" data-id="element-70" data-mp="21uyfh68xg731">
              <XIcon className="h-4 w-4" data-id="element-71" data-mp="1e4uc8zzni9ck" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}